import React, { useState } from 'react';
import moment from 'moment-timezone';
import {
  Box,
  Card,
  CardActionArea,
  Checkbox,
  Chip,
  Tooltip,
  Typography
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HubIcon from '@mui/icons-material/Hub';

const Grid = ({
  header = 'Community Name',
  timeZone,
  error,
  clickHandler,
  address,
  communityPhone,
  timeLabel,
  onboardCommunities,
  apptId,
  removeOnboard,
  isCLOProperty
}) => {
  const [checked, setChecked] = useState(false);
  const handleChange = e => {
    e.stopPropagation();
    setChecked(prev => {
      if (!prev) {
        onboardCommunities(apptId);
      } else {
        removeOnboard(apptId);
      }
      return !prev;
    });
  };

  return (
    <Card
      variant="outlined"
      sx={{
        position: 'relative',
        borderRadius: '8px',
        bgcolor: theme =>
          theme.palette.mode === 'dark'
            ? theme.palette.background.default
            : theme.palette.grey[50],
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <CardActionArea
        onClick={clickHandler}
        sx={{
          p: '12px',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'flex-start'
        }}
      >
        {error && (
          <ErrorOutlineIcon
            sx={{
              color: 'error.main',
              fontSize: '18px',
              position: 'absolute',
              top: 8,
              right: 8
            }}
          />
        )}

        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 500,
            fontSize: '15px',
            color: 'text.primary',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            mb: '4px',
            pr: '32px'
          }}
        >
          {header}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontSize: '12px',
            mb: communityPhone ? '4px' : '10px'
          }}
        >
          {address?.fullAdd}
        </Typography>

        {communityPhone && (
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', fontSize: '12px', mb: '10px' }}
          >
            {communityPhone}
          </Typography>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 'auto'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {timeZone && (
              <Chip
                label={timeZone}
                size="small"
                variant="outlined"
                sx={{ fontSize: '11px', fontWeight: 600, height: '24px' }}
              />
            )}
            {isCLOProperty && (
              <Tooltip title="CLO Property">
                <Chip
                  icon={<HubIcon sx={{ fontSize: '14px' }} />}
                  label="CLO"
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ fontSize: '11px', fontWeight: 600, height: '24px' }}
                />
              </Tooltip>
            )}
          </Box>
          <Typography
            variant="caption"
            sx={{ color: 'text.disabled', fontSize: '10px', fontWeight: 600 }}
          >
            {timeLabel ? moment(timeLabel).format('MMM D, h:mma') : ''}
          </Typography>
        </Box>
      </CardActionArea>

      {!error && (
        <Checkbox
          size="small"
          sx={{
            position: 'absolute',
            top: 2,
            right: 2
          }}
          color="primary"
          checked={checked}
          onClick={handleChange}
        />
      )}
    </Card>
  );
};

export default Grid;
